export default [
    {
        path: '/',
        name: 'home',
        component: () => import('@src/application/home'),
        meta: {
            title: 'Release Notes',
        },
    },
    {
        name: 'logout',
        path: '/logout',
        component: () => import('@src/application/logout.vue'),
        meta: {
            title: 'Logout',
        },
    },
];
